<div class="container-fluid">
  <dl class="row">
    <h4>
      {{ header }}
    </h4>
    <div [innerHtml]="error?.error?.StackTrace"></div>
  </dl>
</div>
